module.exports = __webpack_public_path__ + "img/32_14.44e9a2c4.png";